// extracted by mini-css-extract-plugin
export default {"dotContainer":"WVkEHIp","dotItem":"ZxTMvb0","dot":"HMxnzuu","dot__selected":"kALUr0i"};